import { render, staticRenderFns } from "./ReceiveInvitation.vue?vue&type=template&id=1536b0c6&"
import script from "./ReceiveInvitation.vue?vue&type=script&lang=ts&"
export * from "./ReceiveInvitation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports